<template>
  <div
    class="myPayments no-product-section"
    :class="{ 'no-product-section': noResultFound }"
  >
  <p class="totalAccumulated" v-if="parseFloat(paymentObject.accumulatedAmount) > 0 && (Math.round(parseFloat(paymentObject.transferAfterAccumulated)-parseFloat(paymentObject.accumulatedAmount)) > 0)">{{$t('accumulatedMessage',{dueAmount:Math.round(parseFloat(paymentObject.transferAfterAccumulated)-parseFloat(paymentObject.accumulatedAmount)),leftAmount: parseFloat(paymentObject.transferAfterAccumulated)})}}</p>
    <div v-if="allPayments.length">
      <div class="pay-amount">
        <p class="will-pay">
          Mall91 will Pay :
          <strong>Rs. {{ parseFloat(paymentObject.pendingAmount) }}.0</strong>
        </p>
        <p class="paid">
          Mall91 Paid :
          <strong>Rs. {{ parseFloat(paymentObject.paidAmount) }}.0</strong>
        </p>
      </div>
      <ul class="payment-list">
        <li v-for="(item, index) in allPayments" :key="index">
          <!-- <li> -->
          <div
            class="payment-card"
            @click="viewPaymentDetail(index, item.id, item.paymentRefundStatus)"
          >
            <div class="date-detail">
              <div class="flx">
                <p class="order-id" style="color:blue" v-if="item.orderId">OrderID: #{{item.orderId}}</p>
                <p>{{ item.displayDate }}</p>
                <p
                  class="amount-detail"
                  v-if="item.paymentRefundStatus === 'SUCCESS'"
                  style="color: green"
                >
                  Rs. {{ parseFloat(item.amount) }}.0
                </p>
                <p
                  class="amount-detail"
                  v-else-if="item.paymentRefundStatus === 'PROCESSING' || item.paymentRefundStatus === 'BLOCKED'"
                  style="color: blue"
                >
                  Rs. {{ parseFloat(item.amount) }}.0
                </p>
                <p class="amount-detail" v-else>
                  Rs. {{ parseFloat(item.amount) }}.0
                </p>
              </div>
              <div class="flx" v-if="item.paymentRefundStatus === 'SUCCESS'">
                <span>Mall91 ने भुगतान किये</span>
                <span class="view-detail">View Details</span>
              </div>
              <div
                class="flx"
                v-else-if="item.paymentRefundStatus === 'PROCESSING' || item.paymentRefundStatus === 'BLOCKED'"
              >
                <span
                  >आपका पेमेंट डिले हो रहा है , चिंता ना करें । 100% Mall91 पेमेंट गारंटी है ।<br />
                  <div class="svg_loader"><ProgressBarIcon /></div
                ></span>
                <span class="view-detail">View Details</span>
              </div>
              <div v-else-if="item.paymentRefundStatus === 'FAILED'">
                <div class="flx">
                  <span>Mall91 द्वारा भुगतान नहीं हुआ </span>
                  <span class="view-detail">View Details</span>
                </div>
                <div class="flx retry-option">
                  <p style="color: red">{{ item.failureReason }}</p>
                  <span
                    class="retry"
                    style="margin: 0"
                    @click.stop="retryRequest(item.parentId, item.id)"
                    v-if="clickedRetry"
                    >Retry</span
                  >
                </div>
              </div>
              <div class="flx" v-else>
                <span>Mall91 द्वारा भुगतान नहीं हुआ</span>
                <!-- <span class="view-detail">View Details</span> -->
              </div>
            </div>
          </div>
          <div
            class="modal-pagecnt shippingDetails"
            style="padding-top: 65px"
            v-if="showPaymentDetail === index"
            :class="{ open_modal: showPaymentDetail === index }"
          >
            <header class="fixed_Back_header flx">
              <div class="menu flx">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  @click="closeTrack()"
                >
                  <g fill="#000" fill-rule="evenodd">
                    <path
                      d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
                    />
                    <path
                      d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
                    />
                  </g>
                </svg>
                <h3>Payment Status</h3>
              </div>
            </header>
            <div class="order-track-status" v-if="paymentTrackList">
              <div class="order-state">
                <div
                  class="instatus completed"
                  :class="{ failed: item.paymentRefundStatus === 'FAILED' }"
                  v-for="(orderState, index) in paymentTrackList"
                  :key="index"
                >
                  <h3>{{ orderState.statusMessage }}</h3>
                  <p>{{ orderState.time }}</p>
                  <span
                    class="check"
                    v-if="item.paymentRefundStatus === 'SUCCESS'"
                  ></span>
                  <span
                    class="cross"
                    v-if="item.paymentRefundStatus === 'FAILED'"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <infinite-loading
      @infinite="getPaymentsListing"
      spinner="circles"
      :class="{ visibilityHidden: noResultFound }"
      :identifier="resetIdentifier"
    >
      <template slot="no-more">{{ $t("noMoreRecord") }}</template>
    </infinite-loading>
    <div class="no-product" v-if="noLogFound">
      <div class="no-item-found">
        <div class="img-block">
          <img src="../../assets/images/ic_product_box.svg" />
        </div>
        <div class="details-block">
          <p>No Data Found</p>
        </div>
      </div>
    </div>
    <div class="no-product" v-if="noResultFound">
      <div class="no-item-found" style="    margin-top: 150px;">
        <div class="img-block">
          <img src="../../assets/images/ic_product_box.svg" />
        </div>
        <div class="details-block">
          <p>अभी तक आपका कोई भी रिकॉर्ड नहीं मिला है</p>
        </div>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
  </div>
</template>

<script>
import "../../assets/css/order-history.scss";
import constant from "../../utils/constant";
import InfiniteLoading from "vue-infinite-loading";
import CustomToaster from "../../components/Common/CustomToaster";
import ApiCaller from "../../utils/apicaller";
import AddBankDetails from "../OrderHistorySection/AddBankDetails";
import ProgressBarIcon from "../../components/Icons/ProgressBarIcon";
import Vue from "vue";
export default {
  name: "MyShopTransaction",
  components: {
    InfiniteLoading,
    CustomToaster,
    AddBankDetails,
    ProgressBarIcon,
  },
  data() {
    return {
      allPayments: [],
      pageIndex: 0,
      isValidDetail: false,
      noResultFound: false,
      toasterData: {},
      limit: 20,
      paymentModeList: [
        { name: "Paytm", value: "PAYTM" },
        { name: "Mall91 Wallet", value: "MALL91_WALLET" },
        { name: "Bank UPI", value: "BANK_UPI" },
      ],
      bankDetailsDTO: {
        paymentTransferMode: "MALL91_WALLET",
      },
      isBankDetails: false,
      addedBankDetails: false,
      noBankDetails: false,
      bankDetails: {},
      loading: false,
      paymentObject: {},
      resetIdentifier: +new Date(),
      timerId: null,
      showPaymentDetail: false,
      paymentTrackList: [],
      noLogFound: false,
      clickedRetry: true
    };
  },
  methods: {
    viewPaymentDetail(index, id, status) {
      if (status != null) {
        this.getPaymentStatusPerId(index, id);
      }
    },
    retryRequest(parentId, id) {
      this.clickedRetry = false
      this.loading = true;
      let failId;
      if (parentId) {
        failId = parentId;
      } else {
        failId = id;
      }
      ApiCaller(constant.SELLER_PAYMENT_URL, "failed-payment-retry-v1", "post", {
        sellerPaymentSettlementId: failId,
      })
        .then((data) => {
          this.paymentInterval();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err.response.data.errorCodes[0] == "RETRY_LIMIT_EXCEEDED") {
            this.toasterData = {
              msg:
                "Your retry limit is exceeded for this payment. Please contact to support.",
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
          } else if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = (res) => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.retryRequest(parentId, id);
                } else {
                  this.loading = false;
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          }else {
            this.toasterData = {
              msg: err.response.data.message,
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
          }
          console.log(err);
        });
    },
    closeTrack() {
      this.showPaymentDetail = !this.showPaymentDetail;
      this.paymentTrackList.length = 0;
      this.noLogFound = false;
    },
    addBankdetail() {
      document.querySelector("body").classList.add("bankDetailbody");
    },
    closeCustompop() {
      document.querySelector("body").classList.remove("bankDetailbody");
    },
    sortBy(mode) {
      this.bankDetailsDTO = {
        paymentTransferMode: mode,
      };
    },
    editBankDetail() {
      this.isBankDetails = !this.isBankDetails;
      // this.addedBankDetails = false
    },
    getPaymentStatusPerId(index, id) {
      this.loading = true;
      ApiCaller(constant.USER_PAYMENT_LOG, "get-user-payment-logs/" + id, "get")
        .then((data) => {
          this.loading = false;
          this.paymentTrackList = data.data;
          this.showPaymentDetail = index;
          if (this.paymentTrackList.length) {
          } else {
            this.noLogFound = true;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getBankDetail() {
      ApiCaller(constant.LOCAL_SHOP_URL_ORDER, "get-bank-details", "get")
        .then((data) => {
          this.loading = false;
          this.bankDetails = data.data;
          if (data.data.paymentTransferMode) {
            if (data.data.paymentTransferMode !== "") {
              this.addedBankDetails = true;
              this.isBankDetails = false;
              this.noBankDetails = false;
            }
          } else {
            this.noBankDetails = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = (res) => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.getBankDetail();
                } else {
                  this.loading = false;
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          }
        });
    },

    saveDetail() {
      if (this.bankDetailsDTO.paymentTransferMode === "BANK_UPI") {
        if (this.bankDetailsDTO.bankUpiId) {
          if (this.bankDetailsDTO.bankUpiId.trim().length > 4) {
            if (new RegExp(/^\w+@\w+$/g).test(this.bankDetailsDTO.bankUpiId)) {
              this.loading = true;
              ApiCaller(
                constant.LOCAL_SHOP_URL_ORDER,
                "add-bank-details",
                "post",
                this.bankDetailsDTO
              )
                .then((data) => {
                  this.loading = false;
                  this.getBankDetail();
                })
                .catch((err) => {
                  this.loading = false;
                  if (
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED" ||
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
                  ) {
                    try {
                      _JWT.refereshToken = (res) => {
                        if (res != "fail") {
                          this.$cookie.set("JWT-TOKEN", res);
                          this.saveDetail();
                        } else {
                          this.loading = false;
                        }
                      };
                      JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                    } catch (err) {
                      this.loading = false;
                      console.log(err);
                    }
                  }else if(err.response.data.errorCodes[0] == "INVALID_REQUESTER_ID"){
                      this.toasterData = {
                        msg: "UPI ID is already in use",
                        color: "#e51c24",
                        iconName: "close",
                      };
                      this.isValidDetail = true;
                  }
                });
            } else {
              this.loading = false;
              this.toasterData = {
                msg: "Enter Valid UPI ID",
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return false;
            }
          } else {
            this.loading = false;
            this.toasterData = {
              msg: "Enter Valid UPI ID",
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        } else {
          this.loading = false;
          this.toasterData = {
            msg: "Enter your UPI ID",
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
          return false;
        }
      } else if (this.bankDetailsDTO.paymentTransferMode === "PAYTM") {
        if (this.bankDetailsDTO.phone) {
          if (this.bankDetailsDTO.phone.trim().length > 9) {
            if (
              new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(
                this.bankDetailsDTO.phone
              )
            ) {
              this.loading = true;
              ApiCaller(
                constant.LOCAL_SHOP_URL_ORDER,
                "add-bank-details",
                "post",
                this.bankDetailsDTO
              )
                .then((data) => {
                  this.loading = false;
                  this.getBankDetail();
                })
                .catch((err) => {
                  this.loading = false;
                  if (
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED" ||
                    err.response.data.message ==
                      "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
                  ) {
                    try {
                      _JWT.refereshToken = (res) => {
                        if (res != "fail") {
                          this.$cookie.set("JWT-TOKEN", res);
                          this.saveDetail();
                        } else {
                          this.loading = false;
                        }
                      };
                      JSBridgePlugin.refreshTokens("_JWT.refereshToken");
                    } catch (err) {
                      this.loading = false;
                      console.log(err);
                    }
                  }else if(err.response.data.errorCodes[0] == "INVALID_REQUESTER_ID"){
                      this.toasterData = {
                        msg: "Paytm number is already in use",
                        color: "#e51c24",
                        iconName: "close",
                      };
                      this.isValidDetail = true;
                  }
                });
            } else {
              this.loading = false;
              this.toasterData = {
                msg: "Enter Valid Mobile Number",
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return false;
            }
          } else {
            this.loading = false;
            this.toasterData = {
              msg: "Enter Valid Mobile Number",
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        } else {
          this.loading = false;
          this.toasterData = {
            msg: "Enter your Paytm Number",
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
          return false;
        }
      } else {
        this.loading = true;
        ApiCaller(
          constant.LOCAL_SHOP_URL_ORDER,
          "add-bank-details",
          "post",
          this.bankDetailsDTO
        )
          .then((data) => {
            this.loading = false;
            this.getBankDetail();
          })
          .catch((err) => {
            this.loading = false;
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.saveDetail();
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }
          });
      }
    },
    getPaymentStatus() {
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "get-check-order-payment-status",
        "get"
      ).then((data) => {
        if(data.data=== 'FAIL'){
          clearInterval(this.timerId);
        }
        // this.pageIndex = 0;
        // this.resetIdentifier +=1;
      });
    },
    getPaymentsListing($state) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        ApiCaller(
          constant.LOCAL_SHOP_URL_ORDER,
          "get-transaction-details/" + this.pageIndex,
          "get"
        )
          .then((data) => {
            if (this.pageIndex == 0) {
              this.paymentObject = data.data;
              this.allPayments = [];
            }
            if (
              data.data.sellerPaymentDTOs &&
              data.data.sellerPaymentDTOs.length > 0
            ) {
              // this.allPayments = [];
              this.allPayments.push(...data.data.sellerPaymentDTOs);
              let inStockitem = this.allPayments.filter((it) => {
                return it.paymentRefundStatus === "PROCESSING";
              });
              this.pageIndex += 1;
              this.noResultFound = false;
              $state && $state.loaded();
              if (inStockitem.length) {
                this.getPaymentStatus();
              } else {
                clearInterval(this.timerId);
              }
            } else {
              $state && $state.complete();
            }
            if (this.allPayments.length == 0) {
              this.noResultFound = true;
            }
          })
          .catch((err) => {
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getPaymentsListing($state);
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }
          });
      }
    },
    paymentInterval() {
      let count = 0;
      this.timerId = setInterval(() => {
        if (count < 5) {
          this.pageIndex = 0;
          this.allPayments = []
          this.getPaymentsListing();
          // this.resetIdentifier +=1;
        } else {
          clearInterval(this.timerId);
        }
        count++;
      }, 30000);
    },
  },
  mounted() {
    // this.getBankDetail();
    this.paymentInterval();
  },
};
</script>

<style lang="scss" scoped>
.totalAccumulated{
      color: #0063d3;
    font-size: 0.75em;
    font-weight: bold;
    margin-bottom: 8px;
}
.sidebar-menu {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 99;
  padding: 0 0 16px 0;
  transition: 0.5s;
  transform: translateX(-100%);
  padding-top: 65px;
  &.open-slide {
    transform: translateX(0);
  }
}
.shippingDetails .order-track-status .order-state::before {
  border-left: 2px dashed orange;
  height: 82%;
}
.shippingDetails .order-track-status .order-state:after {
  border-left: 2px dashed #c5c5c5;
  height: 82%;
}
.shippingDetails .order-track-status .order-state .instatus.completed::before {
  background: orange;
  box-shadow: 0 0 0 1px orange;
}
.shippingDetails
  .order-track-status
  .order-state
  .instatus.completed:last-child
  .check {
  transform: rotate(45deg);
  height: 10px;
  width: 5px;
  border-bottom: 3px solid #fff;
  border-right: 3px solid #fff;
  display: block;
  position: absolute;
  top: 5px;
  left: 33px;
  z-index: 9;
}
.shippingDetails
  .order-track-status
  .order-state
  .instatus.completed:last-child
  .cross {
  &:after {
    position: absolute;
    content: "";
    display: block;
    width: 4px;
    height: 0px;
    border: solid #e00;
    border-width: 0 0px 12px 0;
    transform: rotate(45deg);
    left: 33px;
    top: 5px;
    z-index: 9;
  }
  &:before {
    position: absolute;
    content: "";
    display: block;
    width: 4px;
    height: 0px;
    border: solid #e00;
    border-width: 0 0px 12px 0;
    transform: rotate(-45deg);
    left: 33px;
    top: 5px;
    z-index: 9;
  }
}
.shippingDetails
  .order-track-status
  .order-state
  .instatus.completed:last-child::before {
  background: green;
  box-shadow: 0 0 0 1px green;
}
.shippingDetails
  .order-track-status
  .order-state
  .instatus.completed.failed:last-child::before {
  background: white;
  box-shadow: 0 0 0 1px red;
}
.track-result {
  width: 100%;
  display: block;
  text-align: center;
  .success {
    font-size: 4em;
    color: green;
  }
  .failed {
    font-size: 4em;
    color: red;
  }
}
.svg_loader {
  height: 20px;
  margin: 0px auto;
  width: 200px;
  overflow: hidden;
  position: relative;
}
.svg_loader svg {
  position: absolute;
  top: -85px;
  left: -20px;
}
.myPayments {
  &.no-product-section {
    height: calc(100vh - 95px);
  }
  padding: 15px 8px;
  .add-info {
    font-size: 0.875em;
    color: #505050;
    // position: relative;
    z-index: 9;
    .edit-section {
      background: #fff;
      box-shadow: 10px 9px 20px 0px rgba(0, 0, 0, 0.16);
      padding: 8px;
      border-radius: 10px;
      margin: 8px 0;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      p {
        margin-top: 8px;
        &:first-child {
          margin-top: 0;
        }
      }
      .material-icons {
        color: #0063d3;
      }
      strong {
        // color: #0063D3;
      }
    }
    .bank-status {
      margin-bottom: 8px;
      span {
        color: green;
        font-weight: 600;
      }
      .material-icons {
        background: green;
        color: white;
        border-radius: 50%;
        padding: 0px;
        font-size: 1em;
        padding: 4px;
        margin-left: 8px;
      }
    }
    .status-message {
      font-weight: 600;
    }
  }
  .title {
    font-size: 0.875em;
    font-weight: 600;
    margin-top: 8px;
    color: #0063d3;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 9px 0 rgba(0, 0, 0, 0.22);
    background: #fff;
    padding: 8px;
    border-radius: 5px;
    z-index: 1;
    position: relative;
    // border-top-left-radius: 5px;
    // border-top-right-radius: 5px;
  }
}
.heading {
  color: #484848;
  font-size: 1em;
}
.pay-amount {
  display: flex;
  justify-content: space-between;
  font-size: 0.688em;
  color: #727272;
  padding: 8px 0;
  .will-pay {
    strong {
      color: #ff0000;
    }
  }
  .paid {
    strong {
      color: #138708;
    }
  }
}
.payment-list {
  box-shadow: 10px 9px 20px 0px rgba(0, 0, 0, 0.16);

  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: #fff;
  .payment-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0 15px;
    border-bottom: 1px solid #0000001f;
    padding: 8px 0;
    position: relative;

    .date-detail {
      width: 100%;
      .flx {
        justify-content: space-between;
      }
      p {
        font-size: 0.75em;
        font-weight: 600;
      }
      span {
        color: #727272;
        font-size: 0.688em;
        margin-top: 8px;
        display: block;
      }
    }
    .view-detail {
      color: #0066ff !important;
      width: 60px;
      text-align: right;
      font-size: 0.938em;
      padding-top: 8px;
      display: block;
      white-space: nowrap;
      font-weight: 600;
    }
    .retry-option {
      background: #f1f1f1;
      border: 1px solid #ddd;
      margin-top: 8px;
      padding: 8px;
      border-radius: 5px;
      p {
        font-weight: 500;
      }
      span {
        color: #0066ff !important;
        font-weight: 600;
        width: 50px;
        height: 14px;
        text-align: right;
      }
    }
    .amount-detail {
      font-size: 0.75em;
      color: #ff0000;
      font-weight: 600;
      text-align: right;
      p {
      }
    }
  }
}
.tracking_details {
  padding: 0 0 15px 0;
  .tracking_info {
    // position: absolute;
    // width: 92%;
    padding: 6px 0;
    z-index: 1;
    position: relative;
  }
}

.selectTypepay {
  width: 100%;
  margin: 0px 0 10px 0;
  display: block;
  padding: 5px;
  border-radius: 5px;
  font-size: 0.875em;
  color: #000;
  border: 1px solid rgba(0, 0, 0, 0.4);
  // box-shadow: 10px 9px 20px 0px #0000001F;
}
.viewPortcnt {
  // position: absolute;
  background: #fff;
  // width: 92%;
  padding: 8px;
  box-shadow: 0 10px 9px 0 rgba(0, 0, 0, 0.22);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-top: -4px;

  // padding-top: 8px;

  .payBackstatusbox {
    width: 100%;
    display: block;
    text-align: center;

    h3 {
      width: 100%;
      text-align: left;
      font-size: 4vw;
      font-weight: 500;
      padding: 10px 0 10px 0;
      margin: 0;
      color: #000000;
    }
    .inputtextbg {
      width: 96%;
      margin: 0px 0 10px 0;
      display: block;
      padding: 5px;
      border-radius: 5px;
      font-size: 0.875em;
      color: #000;
      border: 1px solid rgba(0, 0, 0, 0.4);
      text-align: left;
    }
  }
  .add-dtl-btn {
    background: #108805;
    color: #fff;
    padding: 8px;
    display: block;
    width: 50%;
    margin: 0 auto;
    text-align: center;
    border-radius: 25px;
  }
}
</style>